














































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import api, { IResult } from "@/ts/functions";
import { IFeeVueModel } from "@/ts/models/IFeeVueModel";
import { IDataVueModel } from "@/ts/models/IDataVueModel";
import builder, { IVueStateCollection } from "@/ts/FormBuilder";
import fieldData from "@/ts/FormData";

@Component({
    props: {
        formType: {
            type: String
        },
        formName: {
            type: String
        },
        isRenewal: {
            type: Boolean
        }
    }
})
export default class FormWrapperTRC extends Vue {

    name: string = "FormWrapperTRC";
    isLoading: boolean = true;
    currentIndex: number = 0;

    title: string = "";
    header: string = "";
    description: string = "";
    fileList: any = null;

    formData: any = { canHaveFees: false, fees: [] };
    vueStates: IVueStateCollection = { formType: "", formName: "", views: [], isRenewal: false };

    get total(): number {
        let fees = this.formData.fees as IFeeVueModel[];

        if (fees.length === 0) return 0;
        let total: number = 0;

        fees.forEach((obj, ix, arr) => total += obj.amount);

        return total;
    }

    /// BEGIN WARTIME ATROCITIES
    /// - this is a bit hacky, need to find a better way to persist file input across child components.
    // this click event is triggered manually since its attached to an input in a hidden div
    updateFiles(): void {
        if (this.formData.attachments.length >= 1) {
            this.$toaster.error("A maximum of 1 Site Plan can be uploaded per permit");
            return;
        }

        let initial = document.getElementById("files") as HTMLInputElement;
        let files = initial.files as FileList;
        if (files.length === 0) return;

        var fileTypeList = ["application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/pdf", "image/jpeg", "image/png"]
        if (!fileTypeList.includes(files[0].type)) {
            this.$toaster.error("Invalid file type.");
            return;
        }

        // for every file added we want to add a new element placeholder for that file
        // setting the 'multiple' attribute on the input only allows selecting multiple files in one go from the same directory
        // by having single file selection and adding multiple inputs, we have the flexibility to add as many files we want from multiple locations
        let input = document.createElement("input") as HTMLInputElement;
        input.id = fieldData.getNewId();
        input.setAttribute("type", "file");
        input.setAttribute("prefix", "files");

        // set the new elements file to the currently selected file
        //input.files = files;
        this.fileList = files;
        (document.getElementById("attachments") as HTMLElement).append(input);

        // remove the currently selected file from the active input control
        initial.setAttribute("files", "");
            
        // update our list of current files on the form
        this.formData.attachments.push({ id: "new", value: input.id, text: files[0].name });
    }

    // this method gets called by a child component via:
    //<code>
    //    this.$parent.removeFile(fileId);
    //</code>
    removeFile(fileId: string): void {
        let item = (this.formData.attachments as IDataVueModel[]).find(a => a.value === fileId);

        // since all '.id' properties do not get serialized we are reusing it as an indicator
        if (this.$props.isRenewal) {
            this.removeFileElement(fileId, "");
            this.removeFileData(fileId);
            return;
        }
        if (item !== undefined && (item as IDataVueModel).id === "new") {
            this.removeFileElement(fileId, "");
            this.removeFileData(fileId);
            this.$toaster.success("File Deleted");
        } else {
            this.$swal({
                type: "warning",
                title: "Delete File?",
                text: "This Change Can Not be Undone.",
                showCancelButton: true,
                showConfirmButton: true
            }).then(result => {
                if (result.value) {
                    this.isLoading = true;
                    this.onFileDeleting(fileId);
                    this.removeFileElement(fileId, "exists");
                    this.removeFileData(fileId);
                }
            });
        }
    }

    // if our 'new' indicator is missing we know this file exists in the db, delete it.
    private onFileDeleting(fileId: string): void {
        api.deleteFile(this.formData.formId, fileId)
            .then(result => {
                if (result.isSuccess) {
                    this.$toaster.success("File Deleted");
                } else {
                    throw new Error(result.message as string);
                }
            })
            //.then(() => this.removeFileElement(fileId))
            //.then(() => this.removeFileData(fileId))
            .catch((error: Error) => this.$toaster.error(error.message))
            .finally(() => this.isLoading = false);
    }

    // updating the DOM
    private removeFileElement(fileId: string, type: string): void {
        //(document.getElementById("attachments") as HTMLElement)
        //   .removeChild(document.getElementById(fileId) as HTMLElement);
        if (type == "" && this.$props.isRenewal == false) {
            document.getElementById(fileId)!.remove();
            document.getElementById(fileId)!.remove();
        } else if (type == "exists") {
            document.getElementById(fileId)!.remove();
            document.querySelectorAll('[for="' + fileId + '"]')[0]!.remove();
        }
    }

    // updating the data model.
    private removeFileData(fileId: string): void {
        let att = this.formData.attachments as IDataVueModel[];
        let index = att.map(a => a.value).indexOf(fileId);
        att.splice(index, 1);
    }
    /// END WARTIME ATROCITIES

    created(): void {
        this.header = builder.getFormHeader(this.$props.formName) + (this.$props.isRenewal == true ? " Renewal" : "");
        this.description = builder.getFormDescription(this.$props.formType, this.$props.formName);
        this.vueStates = builder.getViewStates(this.$props.formType, this.$props.formName, this.$props.isRenewal);
    }

    mounted(): void {
        this.currentIndex = this.vueStates.views.findIndex(route => this.$route.path.endsWith(route.route));
        api.getForm(this.$props.formType, this.$props.formName, this.$route.params.applicationNumber)
            .then(result => this.formData = result)
            .then(() => this.setFees())
            .finally(() => this.isLoading = false);
    }

    private setFees(): void {
        this.formData.canHaveFees = this.$props.formType === "Permits" || this.$props.formName === "LiquidHazardousWaste" || this.$props.formName === "TransferStation";

        if (this.formData.canHaveFees && this.formData.fees.length === 0) {
            this.formData.fees.push(fieldData.getFee(this.$props.formName))
        }
    }

    get canPrevious(): boolean {
        return this.currentIndex > 0;
    }

    previousPage(): void {
        if (this.canPrevious) {
            window.scrollTo(0, 0);
            this.$router.push({ path: this.vueStates.views[this.currentIndex - 1].route, query: this.$route.query });
        }
    }

    get canNext(): boolean {
        return this.currentIndex < this.vueStates.views.length && !this.isSaveDisabled;
    }

    nextPage(): void {
        if (this.canNext) {
            window.scrollTo(0, 0);
            this.$router.push({ path: this.vueStates.views[this.currentIndex + 1].route, query: this.$route.query });
        }
    }

    tryNavigate(index: number): void {
        if (this.isSaveDisabled) {
            this.$toaster.error("Please fix errors before continuing.");
        } else {
            this.$router.push({ path: this.vueStates.views[index].route, query: this.$route.query });
        }
    }

    getRouteClass(value: number): string {
        if (value === this.currentIndex) {
            return "router-link-exact-active router-link-active";
        }
        if (value < this.currentIndex) {
            if (this.vueStates.views[value].error) {
                return "error";
            }
            if (this.vueStates.views[value].visited) {
                return "visited";
            }
        }
        return "";
    }

    save(): void {
        this.saveForm(false);
    }

    cancel(): void {
        this.$swal({
            title: "Are You Sure?",
            text: "You currently have unsaved changes.",
            showCancelButton: true,
            showConfirmButton: true
        }).then(result => {
            if (result.value) {
                this.$router.push({ path: "/" });
            }
        });
    }

    submit(): void {
        this.saveForm(true);
    }

    private saveForm(isSubmit: boolean): void {
        this.isLoading = true;
        let form = this.getFormData(isSubmit);
        
        api.saveForm(this.$props.formType, this.$props.formName, form)
            .then(result => this.onSaveCompleted(result, isSubmit))
            .catch((error: Error) => this.onError(error))
            .finally(() => { this.isLoading = false; });
    }

    private getFormData(isSubmit: boolean): FormData {
        let form = new FormData();
        var applicationNumber = (this.$route.params.applicationNumber == undefined ? "" : this.$route.params.applicationNumber);
        form.append("ApplicationNumber", applicationNumber);
        form.append("AccountNumber", this.formData.accountNumber);
        form.append("Type", this.$props.formType);
        form.append("Name", this.$props.formName);
        form.append("IsSubmit", isSubmit.toString());
        
        form.append("Data", JSON.stringify(this.formData, this.ignoreIds));
        
        let container = document.getElementById("attachments") as HTMLElement;
        /*
        for (let i = 0; i < container.children.length; i++) {
            let input = container.children[i] as HTMLInputElement;
            let files = input.files as FileList;
            form.append(`files[${i}]`, files[0]);
        }
        */
        if (this.fileList != null) {
            for (let i = 0; i < this.fileList.length; i++) {
                form.append('files[${i}]', this.fileList[i]);
            }
        }
        return form;
    }

    private ignoreIds(key: string, value: any): any {
        if (key === "id") {
            return undefined;
        }
        return value;
    }

    private onSaveCompleted(result: IResult, isSubmit: boolean): void {
        if (result.isSuccess) {
            this.redirectSuccess(result.message as string, isSubmit);
        } else {
            this.showValidationErrors(result.message as string[]);
        }
    }

    private redirectSuccess(applicationNumber: string, isSubmit: boolean): void {
        if (isSubmit) {
            this.$router.push({
                name: `${this.$props.formType}ReviewTRC`,
                params: { formName: this.$props.formName, applicationNumber: applicationNumber, facilityId: this.formData.facilityRefId },
                query: this.$route.query
            });
        } else {
            this.$router.push({
                name: "FormSaved",
                params: { applicationNumber: applicationNumber },
                query: this.$route.query
            });
        }
    }

    private showValidationErrors(errors: string[]): void {
        //let html = errors.map(msg => `<li>${msg}</li>`).reduce((a, b, ix, ar) => `${a}${b}`);
        //html = `<ul>${html}</ul>`;
        var strings = errors.toString().split("-- ");
        strings.shift();
        var html = '<ul>'
        for (var i = 0; i < strings.length; i++) {
            let error = strings[i].split(': ')[1];
            html += '<li  style=\"text-align: left;\">' + error.trim() + '</li>';
        }
        html += '</ul>';
        this.$swal({
            title: "Validation Error",
            html: html,
            type: "error",
            showConfirmButton: true
        });
    }

    private onError(error: Error): void {
        this.$swal({
            title: "An Error Has Occurred",
            text: error.message,
            showConfirmButton: true,
            type: "error"
        });
    }

    get isSaveDisabled(): boolean {
        if (this.$props.formType === "Reporting") return false;
        return this.vueStates.views[0].error;
    }

    get isSubmitDisabled(): boolean {
        return this.currentIndex !== this.vueStates.views.length - 1 || this.hasErrors;
    }

    get hasErrors(): boolean {
        return this.vueStates.views.some(val => val.error || !val.visited);
    }
}
